import API from "./restAPI";
import { AxiosResponse } from "axios";

let config = require("../configuration.json");

export function apiGetAllProducts(onlySpecialReceipts:boolean): Promise<AxiosResponse> {
  return API.get(`${config.serverUrl}/api/products/${onlySpecialReceipts}`);
}

export function apiGetAllProductsForColor(
  colorId: number
): Promise<AxiosResponse> {
  return API.get(`${config.serverUrl}/api/productsforcolor/${colorId}`);
}

export function apiGetAllProductsForGroups(
  contextId: string,
  groupId: string,
  subGroupId: string
): Promise<AxiosResponse> {
  return API.get(
    `${config.serverUrl}/api/products/${contextId}/${groupId}/${subGroupId}`
  );
}

export function apiGetProductAlternatives(
  baseName: string,
  colorId: string,
  currentProductId: string // current product is not an alternative and will be excluded
): Promise<AxiosResponse> {
  return API.get(
    `${config.serverUrl}/api/productAlternatives/${baseName}/${colorId}/${currentProductId}`
  );
}


export function apiGetProductsTree(): Promise<AxiosResponse> {
  return API.get(`${config.serverUrl}/api/productstree`);
}

export function apiGetProductDetail(id: number): Promise<AxiosResponse> {
  return API.get(`${config.serverUrl}/api/product/${id}`);
}

export function apiProductCreateOrUpdate(data: any): Promise<AxiosResponse> {
  return API.post(`${config.serverUrl}/api/productcreateorupdate`, data);
}

export function apiDeleteProduct(id: number): Promise<AxiosResponse> {
  return API.delete(`${config.serverUrl}/api/product/${id}`);
}

export function apiGetProductGroups(
  includeProducts: boolean
): Promise<AxiosResponse> {
  return API.get(`${config.serverUrl}/api/productgroups/${includeProducts}`);
}

export function apiGetAllProductGroups(): Promise<AxiosResponse> {
  return API.get(`${config.serverUrl}/api/allproductgroups`);
}
